var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 27C7 17.5725 7 12.8575 9.93 9.93C12.86 7.0025 17.5725 7 27 7C36.4275 7 41.1425 7 44.07 9.93C46.9975 12.86 47 17.5725 47 27C47 36.4275 47 41.1425 44.07 44.07C41.14 46.9975 36.4275 47 27 47C17.5725 47 12.8575 47 9.93 44.07C7.0025 41.14 7 36.4275 7 27Z",
    stroke: "#848484",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 34.5L20.355 20.685C20.4706 20.3402 20.6916 20.0405 20.9868 19.8281C21.2819 19.6158 21.6364 19.5015 22 19.5015C22.3636 19.5015 22.7181 19.6158 23.0132 19.8281C23.3084 20.0405 23.5294 20.3402 23.645 20.685L28.25 34.5M18.25 29.5H25.75M35.75 19.5V34.5M17 2V7M37 2V7M27 2V7M17 47V52M27 47V52M37 47V52M52 37H47M7 17H2M7 37H2M7 27H2M52 17H47M52 27H47",
    stroke: "#848484",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.1d26bae4d6357eb7ecaaab7577b2a837.svg";
export { ForwardRef as ReactComponent };